import React from "react";
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import MainHeader from "../Header/header";
import MyFooter from "../Footer/footer";
import { Parse } from "parse";
import { Layout } from 'antd';
import styled, { keyframes } from 'styled-components'
import "../App.css";
import '../index.css'

import sport37 from '../img/sport-37.jpg'
import sport53 from '../img/sport-53.jpg'
import sport72 from '../img/sport-72.jpg'
import sport133 from '../img/sport-133.jpg'

const { Content } = Layout;

const Contentstyled = styled(Content) `
position: relative;
background: white!important;
`

const Title = styled.h1 `
text-align: center;
margin-top: 30px;
margin-bottom: 30px;
`

const animationName = keyframes`
from {
  transform: translateX(0)
}
to {
  transform: translateX(400)
}
`

const SlowCarrousel = styled.div`
  position: inline-block;
  text-align: center;
  justify-content: center;
  animation: ${animationName} 30s linear;`


class Homepage extends React.Component {


  render() {
    //console.log("CU : ", Parse.User.current())
    if (this.props.user.login === true && this.props.user.redirectToSignUp === false && Parse.User.current() !== null) {
      return (
        <Redirect to='/profile' />
      )
    }
    return (
      <Layout style={{ minHeight: '100vh'}}>
        <MainHeader/>
        <Contentstyled>
          <Title> { `Bienvenue sur l'URBAN APP !`} </Title>
          <div style={{flexDirection: 'row' }}>
            <SlowCarrousel>
              <img
                src={sport37}
                style={{width: '40.7vh'}}
                alt={"urbanAddict1"}
              />
              <img
                src={sport53}
                style={{width: '40.7vh'}}
                alt={"urbanAddict3"}

              />
              <img
                src={sport72}
                style={{width: '40.7vh'}}
                alt={"urbanAddict4"}

              />
              <img
                src={sport133}
                style={{width: '40.7vh'}}
                alt={"urbanAddict5"}

              />
            </SlowCarrousel>
          </div>
        </Contentstyled>
          <MyFooter />
      </Layout>
    );
  }
}

const mapStateToProps = globalReducers => globalReducers

const connectedHomepage = connect(mapStateToProps, null) (Homepage)
export default connectedHomepage


/*<Carouselstyled autoplay>
  <div>
    <img src={test} alt='' style={{width: '70%', height: '80%', display: 'block', marginLeft: 'auto', marginRight: 'auto'}}/>
  </div>
  <div>
    <img src={stretch} alt='' style={{width: '50%', height: '80%', display: 'block', marginLeft: 'auto', marginRight: 'auto'}}/>
  </div>
</Carouselstyled>*/
